import React, {useCallback} from 'react';
import { connect } from 'react-redux';
import  { bindActionCreators } from 'redux';
import {Form, Input, Button, Spin, message} from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { hasErrors } from '../../helpers';
import gestion from '../../Actions/gestionXml';
import { getValueFromQueryString } from '../../helpers';
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
const { requestChangePassword } = gestion.actions;

function RecoverPassword (props) {
		const [form] = Form.useForm();
		const {executeRecaptcha} = useGoogleReCaptcha();
	
		const handleReCaptchaVerify = useCallback(async (formValues) => {
			if (!executeRecaptcha) {
				message.warning('El captcha es incorrecto, refresque la página.');
				return;
			}
			formValues['token'] = await executeRecaptcha('EfiscoRecoveryPassword');
			handleSubmit(formValues)
		}, [executeRecaptcha]);
		const handleSubmit = values => {									
			props.requestChangePassword(values);
			form.resetFields();
		};

		return (			
			<div className="exterior-container">
				<div className="inner-exterior-container" style={{flexDirection: 'column', alignItems: 'center'}}>
					<div className="info-container" style={{maxWidth: '300px', display: 'flex', flexDirection: 'column',alignItems: 'center'}}>
						<img src="./img/logo-efisco.png" alt="efisco" style={{marginBottom: '20px'}} />
						<h2 className="blue-text register-title title-text" style={{marginBottom: 0}}>Recuperar contraseña</h2>
						<p className="label text-center">
							Ingresa tu correo electrónico donde enviaremos las instrucciones para la recuperación de tu contraseña.
						</p>
					</div>
					<Form form={form} layout="vertical" onFinish={handleReCaptchaVerify} autoComplete="off" style={{width: '50%'}}>						
						<Form.Item label="Correo electrónico" 
							name='username'
							rules={[
								{
									type: "email",
									message: "El correo electrónico no es válido"
								},
								{ required: true, message: "¡Favor de introducir su usuario!" }
							]}
						>
							<Input
								prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)'}} />}
								placeholder="correo@ejemplo.com"
							/>
						</Form.Item>					
						<Form.Item>
							<div className="center-button-login">
								<Button type="primary" htmlType="submit">
									Enviar
								</Button>
							</div>
						</Form.Item>
					</Form>		
					{ props.isLoading &&
						<div className="loading-container">
							<Spin size="large" tip="Cargando" />
						</div>
					}
				</div>
			</div>
		)
}

const mapStateToProps = state => {
	return {		
		isLoading: state._genericComponents.loading.isCurrentlyLoading,
		preUserData: state.user.preUserData,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatch,
        ...bindActionCreators({requestChangePassword},dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RecoverPassword);